import React from 'react';
import googleIcon from '../static/img/social-icons/google.svg';
import microsoftIcon from '../static/img/social-icons/microsoft.svg';
import cleverIcon from '../static/img/social-icons/clever.svg';
import classlinkIcon from '../static/img/social-icons/classlink.svg';
import schoologyIcon from '../static/img/social-icons/schoology.svg';

const PROVIDERS = [
  [
    {
      name: 'Google',
      path: '/login/google-oauth2/',
      icon: googleIcon,
    },
    {
      name: 'Microsoft',
      path: '/login/microsoft-graph/',
      icon: microsoftIcon,
    },
  ],
  [
    {
      name: 'Clever',
      path: '/login/clever/',
      icon: cleverIcon,
    },
    {
      name: 'Classlink',
      path: '/login/classlink/',
      icon: classlinkIcon,
    },
  ],
  [
    {
      name: 'Schoology',
      path: '/login/schoology/',
      icon: schoologyIcon,
    },
  ],
];

function SocialSignIn({
  locationPath,
  userType,
  onClick,
  action = 'Sign Up',
  partner = false,
  socialAuth = {},
  variant,
}) {
  // Partner shows Google + Microsoft as full-width buttons; tuvalabs keeps compact ones.
  // A provider is hidden only when its app_config flag is explicitly false.
  const enabledByName = {
    Google: socialAuth.google,
    Microsoft: socialAuth.microsoft,
  };
  const enabledProviders = PROVIDERS[0].filter(
    provider => enabledByName[provider.name] !== false,
  );

  function handleClick(e, provider) {
    e.preventDefault();
    let url = `${provider.path}?next=${locationPath}`;
    if (userType) {
      url += `&type=${userType}`;
    }
    if (onClick) {
      window.location.replace(url);
    } else {
      window.location.href = url;
    }
  }

  function providerHref(provider) {
    return `${provider.path}?next=${locationPath}${
      userType ? '&type=' + userType : ''
    }`;
  }

  const orDivider = (
    <div className="relative my-3">
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-300"></div>
      </div>
      <div className="relative flex justify-center">
        <span className="bg-white px-4 text-base uppercase text-gray-400 tracking-wide">
          OR
        </span>
      </div>
    </div>
  );

  // v2 auth-modal grid (matches the overlay mockup): a 2-column grid of SSO
  // buttons with the last single provider (Schoology) centered. No divider —
  // the auth modal renders its own "or sign in with".
  if (variant === 'grid') {
    const orderedProviders = [].concat(...PROVIDERS).filter(
      provider => enabledByName[provider.name] !== false,
    );
    const lastIsSingle = orderedProviders.length % 2 === 1;
    return (
      <div className="tuva-auth__sso-grid">
        {orderedProviders.map((provider, index) => (
          <a
            key={provider.name}
            href={providerHref(provider)}
            onClick={e => handleClick(e, provider)}
            className={`tuva-auth__sso-btn${
              lastIsSingle && index === orderedProviders.length - 1
                ? ' tuva-auth__sso-btn--center'
                : ''
            }`}
          >
            <img
              src={provider.icon}
              alt={provider.name}
              onError={e => {
                e.target.style.display = 'none';
              }}
            />
            {provider.name}
          </a>
        ))}
      </div>
    );
  }

  if (partner) {
    return (
      <div className="mt-4 max-w-[374px] w-4/5 mx-auto">
        {enabledProviders.map(provider => (
          <a
            key={provider.name}
            href={providerHref(provider)}
            onClick={e => handleClick(e, provider)}
            className="social-btn flex items-center w-full h-10 p-2 mb-4 border border-[#c5cad3] bg-[#f7f7fb] rounded-[3px] hover:bg-gray-100 transition-colors no-underline"
          >
            <img
              src={provider.icon}
              className="h-5 ml-2"
              alt={provider.name}
              onError={e => {
                e.target.style.display = 'none';
              }}
            />
            <span className="flex-1 text-center text-base text-[#3d4146]">
              {action} with {provider.name}
            </span>
          </a>
        ))}
        {enabledProviders.length > 0 && orDivider}
      </div>
    );
  }

  return (
    <div className="mt-4">
      {PROVIDERS.map((row, rowIdx) => (
        <div key={rowIdx} className="flex justify-center gap-6 mb-3">
          {row.map(provider => (
            <a
              key={provider.name}
              href={providerHref(provider)}
              onClick={e => handleClick(e, provider)}
              className="social-btn flex items-center w-[150px] h-10 px-3 border border-gray-300 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors no-underline"
            >
              <img
                src={provider.icon}
                className="h-5 mr-3"
                alt={provider.name}
                onError={e => {
                  e.target.style.display = 'none';
                }}
              />
              <span className="text-base text-gray-600">{provider.name}</span>
            </a>
          ))}
        </div>
      ))}

      {orDivider}
    </div>
  );
}

export default SocialSignIn;
